import styled from 'styled-components'
import { themeGet } from 'styled-system'

const PreviewLink = styled.a`
  border-color: ${themeGet('colors.buttons.previewBackground')};
  color: ${themeGet('colors.buttons.previewBackground')};
  border: 2px solid ${themeGet('colors.buttons.previewBackground')};
  text-decoration: none;
  cursor: pointer;
  padding: 0.52rem 0 0.52rem;
  border-radius: ${themeGet('buttons.borderRadius')};
  min-width: 106px;
  font-family: ${themeGet('fontFamilySemibold')};
  text-align: center;
  text-transform: capitalize;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out,
    border-color 0.2s ease-in-out;

  :disabled {
    background: ${themeGet('colors.buttons.primaryBackgroundDisabled')};
    border-color: ${themeGet('colors.buttons.primaryBackgroundDisabled')};
  }

  h5 {
    color: ${themeGet('colors.buttons.primaryFont')};
  }

  &:hover {
    color: ${themeGet('colors.buttons.primaryFont')};
    background-color: ${themeGet('colors.buttons.primaryBackgroundHover')};
    border-color: ${themeGet('colors.buttons.primaryBackgroundHover')};
  }
`

export default PreviewLink
